import MarkdownMessage from '@gluedigital/markdown-message';
import { ReactNode, useEffect, useState } from 'react';
import FactCheckScopeNotice from 'src/components/FactCheckScopeNotice/FactCheckScopeNotice';
import WidgetAvatar from 'src/components/Widget/WidgetAvatar/WidgetAvatar';
import { useClientConfig } from 'src/hooks/useClientConfig';

import './InitialQuestions.sass';

interface InitialQuestionsProps {
	children: ReactNode;
	showHeader: boolean;
	showScopeNotice: boolean;
}

const InitialQuestions = ({ children, showHeader, showScopeNotice }: InitialQuestionsProps) => {
	const [askQuestions, setAskQuestions] = useState(false);
	const client = useClientConfig();
	const avatar = client ? <WidgetAvatar /> : <span className="bot-avatar" />;
	useEffect(() => {
		const id = setTimeout(() => setAskQuestions(true), 2000);
		return () => {
			clearTimeout(id);
		};
	}, []);
	return (
		<div className="initial-questions">
			<article className="chat-message bot-message">
				{showHeader && (
					<div className="message-wrapper">
						{avatar}
						<div className="text">
							<MarkdownMessage id="initial-questions.text" />
						</div>
					</div>
				)}
			</article>
			{showScopeNotice && <FactCheckScopeNotice inline />}
			{askQuestions && children}
		</div>
	);
};

export default InitialQuestions;
